<script lang="ts">

import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'

import { getSnowflakeTables, getSnowflakeViews } from '@/api'
import SnowflakeDropdown from '@/components/admin/upload/snowflake/SnowflakeDropdown.vue'
import { HttpError } from '@/errors'
import { SnowflakeConfigReponse } from '@/types'

const props = {
  database: {
    type: String,
    default: '',
  },
  schema: {
    type: String,
    default: '',
  },
}

// eslint-disable-next-line no-use-before-define
@Component<SnowflakeDropdownTableview>({
  watch: {
    databaseSchema () {
      this.$emit('input', '')
      this.response = []
      if (this.database && this.schema) {
        this.fetchData()
      }
    },
  },
})
export default class SnowflakeDropdownTableview extends mixins(Vue.extend({ props }), SnowflakeDropdown) {
  tables: SnowflakeConfigReponse[] = []
  views: SnowflakeConfigReponse[] = []
  name = 'table or view'

  get canFetchData () {
    return Boolean(this.username && this.password && this.account && this.database && this.schema)
  }

  get options () {
    return [
      ...this.tables,
      ...this.views,
    ].map((o: { name : string }) => o.name)
  }

  get databaseSchema () {
    // Convenience method for watching
    return this.database + this.schema
  }

  async fetchData () {
    this.fetching = true
    const options = {
      user: this.username,
      password: this.password,
      account: this.account,
      warehouse: this.warehouse,
      database: this.database,
      schema: this.schema,
    }
    try {
      const [tables, views] = await Promise.all([
        getSnowflakeTables(options),
        getSnowflakeViews(options),
      ])
      this.tables = tables
      this.views = views
    } catch (e) {
      if (e instanceof HttpError && e.status === 400) {
        const warning = await e.getJson()
        this.$emit('error', warning)
      } else {
        throw e
      }
    }
    this.fetching = false
  }
}

</script>
